import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import Header from './components/header/Header';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { getStreamingOffer } from './services/api/getStreamingOffer';
import { getStreamingPackage } from './services/api/getStreamingPackage';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  BrowserRouter,
} from 'react-router-dom';
import BestCombiResult from './components/result/bestcombination/BestCombiResult';
import MainStepper from './components/shared/stepper/MainStepper';
import OverviewAndFilter from './components/overviewandfilter/OverviewAndFilter';
import Home from './components/home/Home';
import ProviderPrices from './components/providerprices/ProviderPrices';
import GameFinder from './components/gamefinder/GameFinder';
import { getGames } from './services/api/getGames';
import FavouriteSelection from './components/favouriteselection/FavouriteSelection';
import Test from './components/shared/_test/Test';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:  24 * 60 * 60 * 1000, //1 Day
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});
const streamingofferquery = {
  queryKey: ['streamingoffer'],
  queryFn: () => {
    return getStreamingOffer();
  },
};
const streamingproviderquery = {
  queryKey: ['streamingpackage'],
  queryFn: () => {
    return getStreamingPackage();
  },
};
const gamesquery = {
  queryKey: ['games'],
  queryFn: () => {
    return getGames();
  },
};
queryClient.prefetchQuery(streamingofferquery);
queryClient.prefetchQuery(streamingproviderquery);
queryClient.prefetchQuery(gamesquery);
function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <ReactQueryDevtools initialIsOpen />
          <CssBaseline />
          <Header />
           {/* <Test />  */}
          <BrowserRouter>
            <MainStepper />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="/favouriteselection"
                element={<FavouriteSelection />}
              />
              <Route path="/bestcombination" element={<BestCombiResult />} />
              <Route path="/overviewfilter" element={<OverviewAndFilter />} />
              <Route path="/providerprices" element={<ProviderPrices />} />
              <Route path="/gamefinder" element={<GameFinder />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
